<app-header></app-header>
	<div style="min-height: 60vh;">
		<router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>
	</div>
<app-footer></app-footer>

